(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("touch", [], factory);
	else if(typeof exports === 'object')
		exports["touch"] = factory();
	else
		root["touch"] = factory();
})(this, function() {
return 